<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/html-indent -->
<template>
    <div class="mt-4 pb-4 border-t border-cs-gray-lv-1 pt-4">
        <h3 class="text-sm font-bold text-cs-main-500 mb-3 uppercase tracking-wider flex items-center justify-between">
            <span>Comments</span>
            <span class="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full">{{ rootComments.length }}</span>
        </h3>
        <div v-if="loading" class="text-xs text-gray-500 py-2">
            Loading comments...
        </div>
        <div v-else-if="rootComments.length === 0" class="text-xs text-gray-400 py-2 italic text-center border border-dashed rounded bg-gray-50">
            No comments on this document.
        </div>
        <div v-else class="flex flex-col gap-2 max-h-[400px] overflow-y-auto pr-2 pb-2">
            <div v-for="comment in rootComments" :key="comment.id" 
                class="bg-white border rounded-lg p-3 cursor-pointer hover:border-blue-400 hover:shadow-sm transition-all text-sm group"
                @click="scrollToComment(comment)">
                <div class="flex items-start justify-between mb-1">
                    <div class="font-semibold text-gray-800 truncate pr-2 max-w-[80%] text-xs">
                        {{ comment.user.first_name }} {{ comment.user.last_name }}
                    </div>
                    <div class="text-[10px] text-gray-400 whitespace-nowrap">
                        {{ formatTime(comment.created_at) }}
                    </div>
                </div>
                <div class="text-gray-600 line-clamp-2 text-xs leading-relaxed break-words whitespace-pre-wrap">
                    {{ comment.content }}
                </div>
                
                <div v-if="(comment.replies?.length || 0) > 0" class="mt-2 text-[11px] text-blue-600 font-medium flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"></path>
                    </svg>
                    {{ comment.replies.length }} {{ comment.replies.length === 1 ? 'reply' : 'replies' }}
                </div>
                
                <div class="mt-2 text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
                    Page {{ parseInt(comment.page_number) + 1 }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { formatDistanceToNow } from 'date-fns'

const props = defineProps({
    submissionSlug: {
        type: String,
        required: true
    }
})

const comments = ref([])
const loading = ref(true)
const pollingInterval = ref(null)

const rootComments = computed(() => {
    return comments.value.filter(c => !c.parent_id).sort((a, b) => {
        // Sort by page number first, then by creation date
        if (a.page_number === b.page_number) {
            return new Date(a.created_at) - new Date(b.created_at)
        }
        return a.page_number - b.page_number
    })
})

const formatTime = (timestamp) => {
    try {
        return formatDistanceToNow(new Date(timestamp), { addSuffix: true })
    } catch {
        return ''
    }
}

const scrollToComment = (comment) => {
    const pageElement = document.getElementById(`global-page-${comment.page_number}`)
    if (pageElement) {
        pageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        
        const container = pageElement.parentElement
        if (container) {
            const originalOutline = container.style.outline
            container.style.outline = '3px solid #60a5fa'
            container.style.outlineOffset = '2px'
            container.style.transition = 'outline 0.3s ease'
            
            setTimeout(() => {
                container.style.outline = '3px solid transparent'
                setTimeout(() => {
                    container.style.outline = originalOutline
                }, 300)
            }, 1000)
        }
    }

    window.dispatchEvent(new CustomEvent('show-comment-detail', {
        detail: { commentId: comment.id, pageNumber: comment.page_number }
    }))
}

async function loadComments() {
    if (!props.submissionSlug) return

    try {
        const res = await fetch(`/submissions/${props.submissionSlug}/comments`, {
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
            }
        })
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`)
        comments.value = await res.json()
    } catch (error) {
        console.error('Error loading comments in sidebar:', error)
    } finally {
        loading.value = false
    }
}

const startPolling = () => {
    if (!props.submissionSlug) return
    pollingInterval.value = setInterval(loadComments, 5000)
}

onMounted(() => {
    if (props.submissionSlug) {
        loadComments()
        startPolling()
    } else {
        loading.value = false
    }
})

onUnmounted(() => {
    if (pollingInterval.value) {
        clearInterval(pollingInterval.value)
    }
})
</script>

<style scoped>
/* Scoped styles */
</style>
